exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".container{position:relative;margin:60px auto;padding:0;width:80%;max-width:800px}.article-title,.author-info{text-align:center}.author-info{margin-bottom:45px;height:26px;line-height:26px;vertical-align:middle}.author-info>div{display:inline-block;min-width:90px}.author-info .author-info_avatar{width:26px;height:26px;border-radius:13px;float:left}.author-info .author-info_name{margin-left:12px}.article-content{font-size:22px}.article-content .article-content_p{text-indent:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist!./examples/article/style.css
// module id = 172
// module chunks = 0